const unawareDelay = 1000;
const countdown = 15 * 1000;

export function initTimers() {
  const timers = {
    unawareDelay: unawareDelay,
    nonGalleryDelay: 120 * 1000 - unawareDelay,
    inGalleryDelay: 30 * 1000 - unawareDelay,
    countdown: countdown,
  };
  sessionStorage.setItem('screenSaverTimers', JSON.stringify(timers));
}

function changeScreenSaverTimers(mode) {
  const never = 100000000;
  const nonGallery = mode !== 'never' ? 12000 : never;
  const inGallery = mode !== 'never' ? 6000 : never;
  const timers = {
    unawareDelay: unawareDelay,
    nonGalleryDelay: nonGallery,
    inGalleryDelay: inGallery,
    countdown: countdown,
  };

  sessionStorage.setItem('screenSaverTimers', JSON.stringify(timers));
  window.location.reload();
}

export function exposeChangeTimer() {
  window.parent.changeScreenSaverTimers = changeScreenSaverTimers;
}
